export default __webpack_public_path__ + "static/media/melvin_jones.5ee7e7f9.png";